import React from 'react';
import { Spinner } from '../../spinner/spinner';

type ModalLoadingType = {
    loading?: boolean;
};

export const ModalLoading: React.FC<ModalLoadingType> = ({ loading = false }: ModalLoadingType) => {
    return loading ? (
        <div className="absolute inset-0 z-[100] flex items-center justify-center bg-body/40 backdrop-blur-[0.2rem]">
            <div className="pointer-events-auto flex items-center justify-center">
                <Spinner type={'default'} />
            </div>
        </div>
    ) : null;
};
